import { render, staticRenderFns } from "./UsFaults.vue?vue&type=template&id=12ab4a1e&"
import script from "./UsFaults.vue?vue&type=script&lang=js&"
export * from "./UsFaults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports